<template>
  <div id="app">
    <transition name="animate-fade">
      <div class="toast" v-if="toast.show">
        <b-alert class="toast alert" :show="toast.show" :variant="toast.variant">{{toast.message}}</b-alert>
      </div>
    </transition>
    <dev-banner></dev-banner>
    <b-navbar toggleable="md" variant="light">
      <b-container fluid>
        <b-navbar-toggle target="nav-collapse" v-if="loggedIn"></b-navbar-toggle>
        <b-navbar-brand to="/">
          <img src="/static/img/vosvoco-logo-white-sm.png" alt="Vos Voco">
        </b-navbar-brand>
        <b-collapse is-nav id="nav-collapse" v-if="loggedIn">
          <b-navbar-nav>
            <b-nav-item to="/" exact>Home</b-nav-item>
            
            <b-nav-text class="d-none d-md-block" v-if="inboxTeams.length > 0">|</b-nav-text>
            <b-nav-item-dropdown v-if="inboxTeams.length > 0">
              <span slot="button-content">
                Inbox
                <b-badge variant="primary" v-if="inboxTotal > 0">{{inboxTotal}}</b-badge>
              </span>

              <b-dropdown-item v-for="team in inboxTeams" :key="team.id" :to="'/inbox/' + team.id">
                {{team.name}}
                <b-badge variant="primary" v-if="team.inbox_count > 0">{{team.inbox_count}}</b-badge>
              </b-dropdown-item>
            </b-nav-item-dropdown>

            <b-nav-text class="d-none d-md-block">|</b-nav-text>
            <b-nav-item to="/events">All Events</b-nav-item>

            <b-nav-text class="d-none d-md-block" v-if="canPrint">|</b-nav-text>
            <b-nav-item to="/print" v-if="canPrint">Printing</b-nav-item>

            <!-- <b-nav-text class="d-none d-md-block">|</b-nav-text> -->
            <!-- <b-nav-item to="/reporting">Reporting</b-nav-item> -->
          </b-navbar-nav>
          <b-navbar-nav class="ml-auto">
            <b-nav-item-dropdown :text="userName" right>
              <b-dropdown-item to="/admin" v-if="isServiceWideAdmin">Vos Voco Service Admin</b-dropdown-item>
              <b-dropdown-item to="/manage" v-if="isAdmin">Manage Users, Teams & Permissions</b-dropdown-item>
              <b-dropdown-item to="/settings">Personal Settings</b-dropdown-item>
              <b-dropdown-item href="#" v-on:click.stop.prevent="logout">Log Out</b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </b-collapse>
      </b-container>
    </b-navbar>

    <router-view/>

  </div>
</template>

<style src="./styles/bootstrap.min.css" lang="css"></style>
<style src="./styles/app.scss" lang="scss"></style>

<script>
import Permissions from '@/lib/permissions'
import DevBanner from '@/components/DevBanner'

export default {
  name: 'app',
  components: {
    'dev-banner': DevBanner
  },
  data: function () {
    return {
      // show_toast: false,
      toast: {
        show: false,
        message: null,
        variant: 'primary'
      },
      bgColor: 'white',
      defaultBgColor: 'white'
    }
  },
  watch: {
    bgColor () {
      document.querySelector('body').style.backgroundColor = this.bgColor
    }
  },
  computed: {
    loggedIn () {
      return this.$store.getters.isLoggedIn
    },
    userName () {
      return this.$store.state.user.name
    },
    isServiceWideAdmin () {
      return Permissions.isServiceWideAdmin(this.$store.state.user)
    },
    isAdmin () {
      return Permissions.isAdmin(this.$store.state.user)
    },
    canPrint () {
      return Permissions.canPrint(this.$store.state.user)
    },
    adminCompany () {
      return this.$store.state.adminCompany
    },
    inboxTotal () {
      return this.$store.state.user.teams.reduce((total, team) => { return total + team.inbox_count }, 0)
    },
    inboxTeams () {
      return this.$store.state.user.teams.filter((team) => Permissions.canViewInbox(this.$store.state.user, team))
    }
  },
  methods: {
    logout () {
      this.$store.commit('logout')
      this.$router.push('/session/new')
    },

    showToast (message) {
      this.toast.show = true
      this.toast.message = message
      setTimeout(() => {
        this.toast.show = false
      }, 3000)
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue